// import React, { useState, useCallback, memo, useEffect } from 'react';
// const InputField = memo(({ icon: Icon, name, label, type = 'text', placeholder, value, onChange, error, disabled }) => {
//   return (
//     <div>
//       <label className="block mb-1 text-sm font-medium text-blue-200">
//         <Icon className="inline w-4 h-4 mr-1 text-blue-400" /> 
//         {label.replace('*', '')}
//         {label.includes('*') && (
//           <span className="text-lg text-red-400/70">*</span>
//         )}
//       </label>
//       <input
//         type={type}
//         name={name}
//         value={value}
//         onChange={onChange}
//         disabled={disabled}
//         className={`w-full px-4 py-2.5 bg-white/5 border ${error ? 'border-red-500/50' : 'border-blue-500/30'
//           } rounded-xl focus:outline-none focus:border-blue-400 text-white placeholder-blue-200/50 text-sm ${disabled ? 'opacity-50 cursor-not-allowed' : ''
//           }`}
//         placeholder={placeholder}
//       />
//       {error && <p className="mt-1 text-xs text-red-400">{error}</p>}
//     </div>
//   );
// });

// export default InputField


import React, { memo } from 'react';

const InputField = memo(({ 
  icon: Icon, 
  name, 
  label, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  error, 
  disabled,
  theme 
}) => {
  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgInput = isDark ? 'bg-white/5' : 'bg-gray-100/80';
  const borderInput = isDark ? 'border-blue-500/30' : 'border-gray-300';
  const borderError = isDark ? 'border-red-500/50' : 'border-red-400';
  const borderFocus = isDark ? 'focus:border-blue-400' : 'focus:border-blue-500';
  
  const textColor = isDark ? 'text-white' : 'text-gray-900';
  const placeholderColor = isDark ? 'placeholder-blue-200/50' : 'placeholder-gray-400';
  const labelColor = isDark ? 'text-blue-200' : 'text-gray-700';
  const iconColor = isDark ? 'text-blue-400' : 'text-blue-600';
  const errorColor = isDark ? 'text-red-400' : 'text-red-600';
  
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <div>
      <label className={`block mb-1 text-sm font-medium ${labelColor}`}>
        {Icon && <Icon className={`inline w-4 h-4 mr-1 ${iconColor}`} />}
        {label.replace('*', '')}
        {label.includes('*') && (
          <span className="text-lg text-red-400/70">*</span>
        )}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`w-full px-4 py-2.5 ${bgInput} border ${error ? borderError : borderInput} ${borderFocus} rounded-xl focus:outline-none ${textColor} ${placeholderColor} text-sm ${disabledStyles} transition-colors duration-300`}
        placeholder={placeholder}
      />
      {error && <p className={`mt-1 text-xs ${errorColor}`}>{error}</p>}
    </div>
  );
});

export default InputField;
